import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { ModuleModulesBridge } from './bridges/module_modules.bridge';
import { MODULES_FEATURE_KEY } from './keys';
import { modulesReducer } from './reducers/modules.reducer';
import { ModulesEffects } from './effects/modules.effects';

export function provideModulesStore(): EnvironmentProviders[] {
    return [provideState(MODULES_FEATURE_KEY, modulesReducer), provideEffects(ModulesEffects, ModuleModulesBridge)];
}
